export const IN_PERSON_ASSISTANCE_LINK = 'http://www.ipesaude.rs.gov.br/carta-de-servicos/servicos?servico=1373';
